import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffBalancesListItemQuery } from '../types';
import {
  AFF_BALANCES_LIST_QUERY_KEY,
  AFF_BALANCES_LIST_URL,
  AFF_BALANCES_PERMISSIONS,
} from '../constants';

export default function useAffBalancesListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffBalancesListItemQuery>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffBalancesListItemQuery>>({
    queryKey: [AFF_BALANCES_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffBalancesListItemQuery>>(
      AFF_BALANCES_LIST_URL,
      tableState.value,
      {
        signal,
        permission: AFF_BALANCES_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
